
import WorkspacePremiumIcon from '@mui/icons-material/WorkspacePremium';
import CelebrationIcon from '@mui/icons-material/Celebration';
import LocationCityIcon from '@mui/icons-material/LocationCity';
import AutoFixHighIcon from '@mui/icons-material/AutoFixHigh';
import ShopIcon from '@mui/icons-material/Shop';
import TtkList from './TtkList';
const BridalWearTTK = ({ data }) => {
    return (
        <>

            <div className="row">
                <div className="col-md-12">
                    <div className='row mb-1'>
                        <div className='col-md-4'>
                            <p> <WorkspacePremiumIcon sx={{ fontSize: 20 }} style={{ color: "black" }} />&nbsp;<b>Working Since :</b>&nbsp;<TtkList data={data?.workingSince} /></p>
                        </div>
                        <div className='col-md-4'>
                            <p> <CelebrationIcon sx={{ fontSize: 20 }} style={{ color: "black" }} />&nbsp;<b>Services Offered:</b>&nbsp;<TtkList data={data?.serviceOffered} /></p>
                        </div>
                        <div className='col-md-4'>
                            <p> <AutoFixHighIcon sx={{ fontSize: 20 }} style={{ color: "black" }} />&nbsp;<b>Customization :</b>&nbsp;<TtkList data={data?.customization} /></p>
                        </div>
                    </div>
                    <div className='row'>
                        <div className='col-md-4'>
                            <p> <ShopIcon sx={{ fontSize: 20 }} style={{ color: "black" }} />&nbsp;<b>Store Type :</b>&nbsp;<TtkList data={data?.storeType} /></p>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default BridalWearTTK